import { ApolloClient, HttpLink, InMemoryCache, ApolloLink, Observable } from '@apollo/client'
import Cookies from 'js-cookie'
import {
  API_BASE_URL,
  VENDURE_AUTH_TOKEN_HEADER_KEY,
  VENDURE_CHANNEL_TOKEN_HEADER_KEY,
  VENDURE_LANGUAGE_CODE_HEADER_KEY,
} from '@/config'

const authLink = new ApolloLink((operation, forward) => {
  const authToken = Cookies.get(VENDURE_AUTH_TOKEN_HEADER_KEY)
  const channelToken = Cookies.get(VENDURE_CHANNEL_TOKEN_HEADER_KEY)

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      Authorization: authToken ? `Bearer ${authToken}` : '',
      'vendure-token': channelToken || '',
    },
  }))

  return new Observable((observer) => {
    const subscription = forward(operation).subscribe({
      next: (result) => {
        const context = operation.getContext()
        const response = context.response

        if (response && response.headers) {
          const vendureAuthToken = response.headers.get(VENDURE_AUTH_TOKEN_HEADER_KEY)
          if (vendureAuthToken) {
            const existingAuthToken = Cookies.get(VENDURE_AUTH_TOKEN_HEADER_KEY)
            if (existingAuthToken !== vendureAuthToken) {
              Cookies.set(VENDURE_AUTH_TOKEN_HEADER_KEY, vendureAuthToken)
            }
          }
        }
        observer.next(result)
      },
      error: (error) => observer.error(error),
      complete: () => observer.complete(),
    })

    return () => {
      if (subscription) subscription.unsubscribe()
    }
  })
})

const httpLink = new HttpLink({
  uri: () => {
    const languageCode = Cookies.get(VENDURE_LANGUAGE_CODE_HEADER_KEY)
    let baseUri = `${API_BASE_URL}/shop-api`
    if (languageCode) {
      baseUri += `?languageCode=${languageCode}`
    }
    return baseUri
  },
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})

export default client
